module.exports = __webpack_public_path__ + "static/img/downT.89cd9254.png";